import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref } from 'vue';
import type { PropType } from 'vue';
import { Tooltip } from 'ant-design-vue';
import { ProductRowItem } from '@/interfaces/general/ProductRowItem';
import { ActiveProductFormValueObject } from '@/interfaces/general/ActiveProductFormValueObject';
import { UpdateProductFormEntry } from '@/interfaces/components/configurator/UpdateProductFormEntry';
import { ChecklistField } from '@/interfaces/components/configurator/ChecklistField';
import Offer from '@/models/Offer';
import { filterProductsFromOfferItems as filterOfferItems } from '@/helpers/OfferItemTableHelper';
import OfferItem from '@/models/OfferItem';
import OfferTitle from '@/models/OfferTitle';
import { TransformedTableOfferItem } from '@/interfaces/components/ProductsInOffer/TransformedTableOfferItem';
// @ts-ignore
import is from 'is_js';
import RichTextEditor from '@/components/views/CmsIndex/RichTextEditor.vue';
import store from '@/store';

/* === Props & Emits === */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCombinationsHeader',
  props: {
    productData: { type: Object as PropType<ProductRowItem>, required: true },
    activeItemRows: { type: Array as PropType<ProductRowItem[]>, required: true },
    hiddenIndices: { type: Array as PropType<boolean[]>, required: true },
    isLoading: { type: Boolean, default: false },
    isCustomProduct: { type: Boolean, default: false },
    offer: { type: Object as PropType<Offer | null>, default: null },
    isCombinationSelectionActive: { type: Boolean, default: false },
    level: { type: Number, required: false },
},
  emits: ['is-connected', 'is-production'],
  setup(__props, { expose, emit }) {

const props = __props;





/* === State & Store Access === */
const wrapper = ref<HTMLElement | null>(null);
const imageWrapper = ref<HTMLElement | null>(null);
const text = ref<any>(null);
const isModalVisible = ref(false);
const modalChecklistField = ref<ChecklistField | null>(null);

expose({ wrapper });

const updateActiveProductFormValue = (entry: UpdateProductFormEntry) =>
    store.dispatch('configurator/updateActiveProductFormValue', entry);
const getProductFormValues = (productFormId: number): ActiveProductFormValueObject | null =>
    store.getters['configurator/activeProductForm'](productFormId);

/* === Field Information Modal === */
function toggleInfoDetailsModal(checklistField: ChecklistField | null) {
    if (checklistField && checklistField.description == null) {
        return;
    }
    isModalVisible.value = !isModalVisible.value;
    modalChecklistField.value = isModalVisible.value ? checklistField : null;

    if (isModalVisible.value && is.safari()) {
        nextTick(() => {
            const modalInner = document.querySelector('.ant-modal-body') as HTMLElement;
            const textHeight = text.value.getBoundingClientRect().height;
            const modalInnerHeight = modalInner.getBoundingClientRect().height;

            imageWrapper.value!.style.height = modalInnerHeight - textHeight - 110 + 'px';
        });
    }
}

function filterProductsFromOfferItems(offerItems: Array<OfferItem | OfferTitle | TransformedTableOfferItem>) {
    return filterOfferItems(offerItems, false);
}

return { __sfc: true,props, emit, wrapper, imageWrapper, text, isModalVisible, modalChecklistField, updateActiveProductFormValue, getProductFormValues, toggleInfoDetailsModal, filterProductsFromOfferItems, Tooltip, RichTextEditor }
}

})